import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';

import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";

//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes, { number } from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
//import styled, { css } from "styled-components";



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    
    this.onApply = this.onApply.bind(this);
    this.onApplyData = this.onApplyData.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmtoggle1 = this.SuccessConfirmtoggle1.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.handleChangeASN = this.handleChangeASN.bind(this);
    this.handleChangeVan1 = this.handleChangeVan1.bind(this);

    this.changeEAN = this.changeEAN.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getTaskList = this.getTaskList.bind(this);
    this.getMCCode = this.getMCCode.bind(this);
    this.getTaskTypeList = this.getTaskTypeList.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.updateEan = this.updateEan.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggleOKNew = this.toggleOKNew.bind(this);
    this.toggleNew = this.toggleNew.bind(this);
    this.changeArticleId = this.changeArticleId.bind(this);
    this.onGroupNameChange = this.onGroupNameChange.bind(this);
    this.toggleNPICancel = this.toggleNPICancel.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onConfirmProduct = this.onConfirmProduct.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.onApply2 = this.onApply2.bind(this);
    this.changeLongName = this.changeLongName.bind(this);
    this.changeShortName = this.changeShortName.bind(this);
    this.changeDesc = this.changeDesc.bind(this);
    this.changeMargin = this.changeMargin.bind(this);
    this.changeItemType = this.changeItemType.bind(this);
    this.changeCostPrice = this.changeCostPrice.bind(this);
    this.changeSellingPrice = this.changeSellingPrice.bind(this);
    this.changeHSNCode = this.changeHSNCode.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeOutlet = this.ChangeOutlet.bind(this);
    this.AssignData = this.AssignData.bind(this);
    this.AssignData1 = this.AssignData1.bind(this);

    this.Failedtoggle = this.Failedtoggle.bind(this);
    this.getVanList = this.getVanList.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);


    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
      orderdata: [],
      arr_data1: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      totalTonnage: 0,
      totalWeightVal: 0,
      modalNew: false,
      createDisabled: false,
      tooltipOpen: false,
      showCreatedId: false,
      showFilter: false,
      ShowConfirmLoader: false,
      reasonData: [],
      totalBillVal: 0,
      selectedVan1: "",
      selectedLocation1: "",
      showSelectGroup: false,
      showNewGroup: false,
      unAssignOrder: [],
      van_list: [],
      assignOrder: [],
      isDisabledSearch: false,
      autoDesc: "",
      selectedDistributor: "",
      put_by: "",
      isChecked: false,
      autoLongName: "",
      autoShortName: "",
      showConfirmError: false,
      zoneData: [],
      reviewData: [],
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      FailedModal: false,
      receiving_config_outer: false,
      receiving_config_inner: true,
      receiving_config_each: true,
      dispatch_config_inner: true,
      dispatch_config_each: true,
      dispatch_config_outer: false,
      pkd_required: false,
      non_ptl: false,
      batch_required: false,

      fragile_item: false,

      fromScreen: false,
      order: [],
      row_data: [],
      arr_data: [],
      Polaris: [],
      task_type: [],
      pack_size1: [],
      item_data:{},
      variant1: [],
      task: [],
      store: [],
      distributor:[],
      areaCode:[],
      location: [],
      EditModal: false,
      selectedVanFilter: "",
      fromdate: "",
      todate: "",
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      assignLoader: false,
      assignDisabled: true,
      status_type: "1",
      apply: true,
      store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      volumeCheck: false,
      dimensionCheck: false,
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
    
      showFetchDispatchData: true,
      ean_list: [],
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",

      apply1: true,
      total_value: "",
      total_quantity: "",

      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      weight: "",
      volume: "",
      bill_number: "",
      bill_range: "",
      bill_value: "",
      pl_group: "",
      area_code: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      failed_message: "",
      showAllItem: false,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      shelf_life : "",
      mrsl : ""
      
    };
  }

  Assign(){
      this.fetchDispatch();


  }

  onGroupNameChange(e){
    this.setState({
      groupName: e.target.value
    })
  }

  toggleTooltip(){
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })
      })
      .catch(function(error) {});

  }



  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

  ChangeStation(evt, index) {
    const {reviewData} = this.state;
    var Station = evt.target.value
    reviewData[index]['station'] = Station

    console.log(reviewData);

    this.setState({
      reviewData: reviewData
    })


  };

  ChangeZone(evt, index) {
    const {reviewData} = this.state;
    var Zone = evt.target.value
    reviewData[index]['zone'] = Zone

    console.log(reviewData);

    this.setState({
      reviewData: reviewData
    })


  };

  changeBrand = (evt) => {
    this.setState({
      brand_value: evt.target.value,
      brand: evt.target.value,
    });
  };
  changeArticleId = (evt) => {
    this.setState({
      article_id: evt.target.value,
    });
  };

  changeLongName = (evt) => {
    this.setState({
      autoLongName: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  changeShortName = (evt) => {
    this.setState({
      autoShortName: evt.target.value,
    });
  };

  changeDesc = (evt) => {
    this.setState({
      autoDesc: evt.target.value,
    });
  };

  changeSellingPrice = (evt) => {
    this.setState({
      autoSellingPrice: evt.target.value,
    });
  };

  changeCostPrice = (evt) => {
    this.setState({
      autoCostPrice: evt.target.value,
    });
  };
  changeHSNCode = (evt) => {
    this.setState({
      autoHsnCode: evt.target.value,
    });
  };

  changeItemType = (evt) => {
    this.setState({
      autoItemtype: evt.target.value,
    });
  };

  changeMargin = (evt) => {
    this.setState({
      autoMargin: evt.target.value,
    });
  };

  viewImage() {
    //window.open('/view_image','_blank');
    this.props.history.push("/npi_request_data");
  }

  onApplyData() {
    this.setState({
      loader1: true,
      isDisabledApply: true,
    });

    if (
      (this.state.mc_code_value == "" ||
        this.state.mc_code_value == "undefined" ||
        this.state.mc_code_value == undefined) &&
      (this.state.article_id == "" ||
        this.state.article_id == "undefined" ||
        this.state.article_id == undefined)
    ) {
      this.setState({
        mc_error: true,
        loader1: false,
        isDisabledApply: false,
      });
      return false;
    } else {
      this.setState({
        mc_error: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "hsn_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          hsn_code: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant_data: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "shelf_life",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          shelf_life_data: response.data.data,
          //loader1: false,
          isDisabledApply: false,
        });
      })
      .catch(function(error) {});

    this.onApply();
  }

  changeMCCode = (evt) => {
    this.setState({
      mc_error: false,
      mc_code_value: evt.target.value,
    });
  };

  AssignData(){
    this.setState({
      assignLoader: true,
      assignDisabled: true
    })
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

     var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }
    var req_id = [];

   
   /*for(var i = 0; i< this.state.arr_data.length; i++){
    if(this.state.arr_data[i].isChecked == true){
     
      req_id = [...req_id, ...this.state.arr_data[i].req_ids];
      

    }
   }*/

    const payload = {
      //location: this.state.selectedLocation,
          //type: "assign",
          van_id: this.state.selectedVan1,
          order_id: arr,
          group_id: this.state.selectedGroup
          //req_ids: req_id
  };

API.post('/master_ptl/van/v1/assign/', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        if(response.data.success == true){
          this.toggle();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false
        })
        
        this.getBillList();
      })
      .catch(function(error) {});

  }



  AssignData1(){
    var pkd_required = 0;
    var batch_required = 0;
    var fragile_item = "";
    var receiving_config = "";
    var dispatch_config = "";
    if(this.state.pkd_required == true){
      pkd_required = 1;
    }else{
      pkd_required= 0;
    }

    if(this.state.batch_required == true){
      batch_required = 1;
    }else{
      batch_required = 0
    }

    if(this.state.batch_required == true){
      batch_required = 1;
    }else{
      batch_required = 0
    }

    if(this.state.fragile_item == 0){
      fragile_item = "No"
    }else{
      fragile_item = "Yes"
    }

    if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == false && this.state.receiving_config_each == false){
      receiving_config = 0
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == true && this.state.receiving_config_each == false){
      receiving_config = 1
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == false && this.state.receiving_config_each == true){
      receiving_config = 2
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == true && this.state.receiving_config_each == true){
      receiving_config = 3
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == true && this.state.receiving_config_each == false){
      receiving_config = 4
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == true && this.state.receiving_config_each == true){
      receiving_config = 5
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == false && this.state.receiving_config_each == true){
      receiving_config = 6
    }else{
      receiving_config= ""
    }

     if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == false){
      dispatch_config = 0
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == false){
      dispatch_config = 1
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == true){
      dispatch_config = 2
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == true){
      dispatch_config = 3
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == false){
      dispatch_config = 4
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == true){
      dispatch_config = 5
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == true){
      dispatch_config = 6
    }else{
      dispatch_config= ""
    }

    if(this.state.upc == 0){
      this.setState({
        failed_message: "UPC should not be 0. Please Update UPC"
      })
      this.toggleFailed();
      return false;
    }

    if(this.state.each_weight == 0){
      this.setState({
        failed_message: "Each Weight should not be 0"
      })
      this.toggleFailed();
      return false;
    }

    if(this.state.upc == 1){
      this.setState({
        failed_message: "UPC should not be 1. Are you sure you want to proceed."
      })
      this.Failedtoggle();
      return false;

    }
    if(this.state.mrsl > 100){
      this.setState({
        failed_message: "MRSL cannot be greater than 100 %"
      })
      this.Failedtoggle();
      return false;

    }

    const payload = {
      product_id: this.state.sku_code_val,
      group_id: this.state.selectedGroup,
      receiving_config: receiving_config,
      "dispatch_config": dispatch_config,
      put_by: parseInt(this.state.put_by),
      "pkd_required": pkd_required,
      "batch_required": batch_required,
      "fragile": fragile_item,
      "non_ptl": this.state.non_ptl,
      "upc": this.state.upc,
      "cpo": this.state.cpo,
      "each_length": this.state.each_length,
      "each_breadth": this.state.each_breadth,
      "each_height": this.state.each_height,
      "each_weight": this.state.each_weight,
      "inner_length": this.state.inner_length,
      "inner_breadth": this.state.inner_breadth,
      "inner_height": this.state.inner_height,
      "inner_weight": this.state.inner_weight,
      "outer_length": this.state.outer_length,
      "outer_breadth": this.state.outer_breadth,
      "outer_height": this.state.outer_height,
      "outer_weight": this.state.outer_weight,
      "shelf_life" : this.state.shelf_life,
      "mrsl" : this.state.mrsl,
          
  };

  addAnalytics('Update Missing Product', 'Update Data', payload);

  API.post('/product/updateProductInfo', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          success_message: response.data.reason
          
        });
        this.toggleNew();
        //this.fetchDispatch();
      })
      .catch(function(error) {});

  }





  UpdateData = () => {
    this.setState({
      Failedmodal: false
    })
    var pkd_required = 0;
    var batch_required = 0;
    var receiving_config = "";
    var fragile_item = "";
    var dispatch_config = "";
    if(this.state.pkd_required == true){
      pkd_required = 1;
    }else{
      pkd_required= 0;
    }

    if(this.state.batch_required == true){
      batch_required = 1;
    }else{
      batch_required = 0
    }

    if(this.state.batch_required == true){
      batch_required = 1;
    }else{
      batch_required = 0
    }
     if(this.state.fragile_item == 0){
      fragile_item = "No"
    }else{
      fragile_item = "Yes"
    }

    if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == false && this.state.receiving_config_each == false){
      receiving_config = 0
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == true && this.state.receiving_config_each == false){
      receiving_config = 1
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == false && this.state.receiving_config_each == true){
      receiving_config = 2
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == true && this.state.receiving_config_each == true){
      receiving_config = 3
    }else if(this.state.receiving_config_outer == false && this.state.receiving_config_inner == true && this.state.receiving_config_each == true){
      receiving_config = 5
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == false && this.state.receiving_config_each == true){
      receiving_config = 6
    }else if(this.state.receiving_config_outer == true && this.state.receiving_config_inner == true && this.state.receiving_config_each == false){
      receiving_config = 4
    }else{
      receiving_config= ""
    }

     if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == false){
      dispatch_config = 0
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == false){
      dispatch_config = 1
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == true){
      dispatch_config = 2
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == true){
      dispatch_config = 3
    }else if(this.state.dispatch_config_outer == false && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == true){
      dispatch_config = 5
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == false && this.state.dispatch_config_each == true){
      dispatch_config = 6
    }else if(this.state.dispatch_config_outer == true && this.state.dispatch_config_inner == true && this.state.dispatch_config_each == false){
      dispatch_config = 4
    }else{
      dispatch_config= ""
    }


    const payload = {
      product_id: this.state.sku_code_val,
      group_id: this.state.selectedGroup,
      receiving_config: receiving_config,
      "dispatch_config": dispatch_config,
      put_by: parseInt(this.state.put_by),
      "pkd_required": pkd_required,
      "non_ptl": this.state.non_ptl,
      "batch_required": batch_required,
      "fragile": this.state.fragile_item,
      "upc": this.state.upc,
      "cpo": this.state.cpo,
      "each_length": this.state.each_length,
      "each_breadth": this.state.each_breadth,
      "each_height": this.state.each_height,
      "each_weight": this.state.each_weight,
      "inner_length": this.state.inner_length,
      "inner_breadth": this.state.inner_breadth,
      "inner_height": this.state.inner_height,
      "inner_weight": this.state.inner_weight,
      "outer_length": this.state.outer_length,
      "outer_breadth": this.state.outer_breadth,
      "outer_height": this.state.outer_height,
      "outer_weight": this.state.outer_weight,
          
  };

API.post('/product/updateProductInfo', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          success_message: response.data.reason
          
        });
        this.toggleNew();
        //this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr

  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }


  checkAll1() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: true,
      }));
       var arrayData = newData.filter(
      (item) => item.isChecked === true
    );

       var totalBill = 0;
     var totalWeight = 0;
     var totalValue = 0;


     for(var i = 0 ; i < arrayData.length; i++){
      var totalBill1 = arrayData[i].bill_count;
      var totalBillValue = totalBill + totalBill1;
      totalBill = totalBillValue;

      var totalWeight1 = arrayData[i].weight;
      var totalWeightValue = totalWeight + totalWeight1;
      totalWeight = totalWeightValue;

      var totalValue1 = arrayData[i].value;
      var totalValueTonnage = totalValue + totalValue1;
      totalValue = totalValueTonnage;
     }
  
   
     

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
         totalBillVal: totalBill,
      totalWeightVal: totalWeight.toFixed(2),
      totalTonnage: totalValue.toFixed(2),
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
        totalBillVal: 0,
      totalWeightVal: 0,
      totalTonnage: 0
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }


  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }



  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    console.log(newData);
    this.setState({
      tableRowsMap1: this.assembleDispatchData1(newData),
      //binData: newData,
    });

    

    
  }


  checkedSingle1(index, ischecked,orderid) {
    
    var arr=[];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data1;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    console.log(newData);
    

     
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      arr_data1: newData,
     
      //binData: newData,
    });

    

    
  }


  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };


  toggleOKNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    //this.fetchDispatch();
    window.location.href= '/receiving/view_missing_product';
  }

  toggleNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    this.fetchDispatch();
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle() {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }
  toggle1(type,value) {
    this.setState((prevState) => ({ modal1: !prevState.modal1, title_val: type, ean_val: value }));
    const payload = {
      product_id: this.state.sku_code_val,
      ean_type: value,
  };

API.post('/product/fetchEANInfo', { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          ean_list: response.data,
        });
      })
      .catch(function(error) {});


  }

  toggleNPICancel() {
    this.setState((prevState) => ({
      modal1: !prevState.modal1,
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
    var arrayData = this.state.arr_data.filter(
      (item) => item.van_master == ""
    );

    var errMsg = arrayData.length + " " + "Bills are not assigned to any van"

    if(arrayData.length > 0){
      this.setState({
        reviewErr: errMsg
      })
    }else{
      this.setState({
        reviewErr: ""
      })

    }
    const payload = {
     //location: this.state.selectedLocation,
     group_id: this.state.selectedGroup,
  };

API.post('/master_ptl/van/v1/orders/', { param: payload })
      .then((response) => {
        console.log(response);
        let reviewDataVal = response.data.data.map((item) => ({
          ...item,
          station: "",
          zone: ""
        }));
        this.setState({
          reviewData: reviewDataVal,
        });

      })
      .catch(function(error) {});
  }

  toggleFailed = () => {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  getVariant = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  radioChange = (item_code) => {
    this.setState({
      sku_code: item_code,
      
    });
  }

  getPacksize = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  changeHSN = (e) => {
    const value = e.target.value;
    this.setState({
      hsn_value: value,
      autoHsnCode: value,
    });
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "tax_percentage",
          hsn_code: e.target.value,
          mc_code: this.state.mc_code_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          tax_percentage: response.data.data,
          applyTax: response.data.data,
          tax_percentage1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }


   SuccessConfirmtoggle1() {
    this.setState((prevState) => ({
      SuccessConfirmmodal1: !prevState.SuccessConfirmmodal1,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }

     var today = new Date();
    console.log(today)
    /* From_Date_val = this.convertDate(today);
      to_Date_val = this.convertDate(today);*/
      From_Date_val = "";
      to_Date_val = "";
   
    var prod_id = sessionStorage.getItem('sku_code');
  
    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    var invenOwner = this.getCookie("invOwner");
    this.setState(
      {
        userName: cookieUsername,
        invenOwner: invenOwner,
        sku_code_val: prod_id,
        //fromdate:today,
        //todate:today,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        const params = new URLSearchParams(window.location.search);
        const fromScreen = params.get('fromScreen') === 'true';

        this.setState({ fromScreen });

        // Call API if fromScreen is true
        if (fromScreen) {
            this.fetchDispatch(prod_id);
        }
        //this.fetchDispatch(prod_id);
        //this.getOutletList();
        //this.getTaskList();
        //this.getMCCode();
        //this.getTaskTypeList();
        /*this.getVariant();
        this.getPacksize();*/
      }
    );

    //console.log("2n value")

    //localStorage.setItem('userName' , username);
    /*this.fetchDispatch();
      this.fetchDispatch();
      this.getStoreList();
      this.getTaskList();
      this.getPolarisList();
      this.getTaskTypeList();
      this.getVariant();
      this.getPacksize();*/
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
   var order_count = 0;
   var order_value = 0;
   var box_count = 0;
   var req_id = [];

   var area_code = [];
   for(var i = 0; i< this.state.arr_data.length; i++){
    if(this.state.arr_data[i].isChecked == true){
      order_count += this.state.arr_data[i].order_count;
      order_value += this.state.arr_data[i].order_value;
      box_count += this.state.arr_data[i].box_count;
      req_id = [...req_id, ...this.state.arr_data[i].req_ids];
      area_code.push(this.state.arr_data[i].area_code);


    }
   }

   var area_code_data = area_code.join(',')

   console.log("order_count",order_count, "order_value", order_value, "box_count", box_count, "req_id", req_id, "area_code",area_code.join(','));

   //return false;

    const payload = {
      location: this.state.selectedLocation,
      name: this.state.groupName,
      order_count: order_count,
      order_value: order_value,
      box_count: box_count,
      req_ids: req_id,
      area_code: area_code_data
  };

API.post('/sdr/vans/v1/create/', { param: payload })


      .then((response) => response.data)

      .then((data) => {
       console.log(data);

        this.setState({ selectedVan: data.data.van_id,showCreatedId: true, createDisabled: true, assignDisabled: false });
      })

      .then(async () => {
        
      });
   

    
  }

  getMCCode() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "mc_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        console.log(response.data.data);

        this.setState({
          mc_code: true,
          mc_code_data: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getTaskTypeList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_types",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task_type: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getStoreList() {
     const payload = {
      screen_type: "pick_pack_planning",
  };

API.post('/product/product_master/v1/group/detail/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
       console.log(data);
        this.setState({ store: data.data });
      })

      .then(async () => {
        
      });
  }

  getVanList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "customer_master",
      resp_type: "dropdown"
  };

API.post('/master_ptl/van/v1/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ van_list: response.data.data });
      })

      .then(async () => {
        
      });
  }

  getLocationList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "delivery_center",
      resp_type: "dropdown"
  };

API.post('/customer/view/v1/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ location: response.data.data[0] });
      })

      .then(async () => {
        
      });
  }


  getOutletList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "outlet_master",
      resp_type: "dropdown"
  };

API.post('/sdr/orders/v1/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ areaCode: response.data.data });
      })

      .then(async () => {
        
      });
  }



  createGroup() {

    this.SuccessConfirmtoggle();
    
  }

  getTaskList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_ids",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  onQuantityChangeBrand = (e) => {
    const value = e.target.value;
    this.setState({
      new_brand: value,
    });
  };

  onQuantityChangeShelf = (e) => {
    const value = e.target.value;
    this.setState({
      autoShelfLife: value,
      shelf_life: value,
    });
  };

  changePackSize = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.pack_size1.find(
        (item) => item.id == e.target.value
      );

      this.setState({
        applyPackSize: clickedOption.name,
        pack_unit: clickedOption.unit,
        autoPackSize: clickedOption.name,
        showPackSize: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showPackSize: false,
        });
      } else {
        this.setState({
          showPackSize: true,
        });
      }

      this.setState({
        //showPackSize: true,
        applyPackSize: "",
        pack_unit: "",
        autoPackSize: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "pack_size_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            pack_size_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeShelfLife = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.shelf_life_data.find(
        (item) => item.id == value
      );

      this.setState({
        applyShelfLife: clickedOption.name,
        shelf_unit: clickedOption.unit,
        autoShelfLife: clickedOption.name,
        showShelfLife: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showShelfLife: false,
        });
      } else {
        this.setState({
          showShelfLife: true,
        });
      }
      this.setState({
        /*showShelfLife: true,*/
        applyShelfLife: "",
        shelf_unit: "",
        autoShelfLife: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "shelf_life_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            shelf_life_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
    });

    if (e.target.value == "others") {
      this.setState({
        showVariant: true,
        applyVariant: "",
        autoVariant: "",
      });
    } else {
      this.setState({
        showVariant: false,
        autoVariant: value,
      });
    }
  };

  changeManualPack = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackSize: value,
      autoPackSize: value,
    });
  };

  changeManualVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
      autoVariant: value,
    });
  };

  changeManualShelf = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfLife: value,
      autoShelfLife: value,
    });
  };

  changeMrp1 = (e) => {
    const value = e.target.value;
    this.setState({
      applyMrp: value,
      mrp: value,
    });
  };

  changePackUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackUOM: value,
      pack_unit: value,
    });
  };

  /*changePackUOM=(e) =>{
     const value = e.target.value
    this.setState({
      applyPackUOM: value
    })


  }*/

  changeShlefUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfUOM: value,
      shelf_unit: value,
    });
  };

  onItemCodeChange = (e) => {
    const value = e.target.value;
    this.setState({
      item_code: value,
      
    });
  };

  onMRPChange = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      
    });
  };

  onBillRangeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_range: value,
      
    });
  };

   onBillValueeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_value: value,
      
    });
  };

  onWeightChange = (e) => {
    const value = e.target.value;
    this.setState({
      weight: value,
      
    });
  };

  onVolumeChange = (e) => {
    const value = e.target.value;
    this.setState({
      volume: value,
      
    });
  };

  onVanFilterChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedVanFilter: value,
      
    });
  };



  changeProductName = (e) => {
    const value = e.target.value;
    this.setState({
      autoProductName: value,
      color_product: false,
    });
  };

  onQuantityChangePackSize = (e) => {
    const value = e.target.value;
    this.setState({
      autoPackSize: value,
      packSize: value,
      color_packSize: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  onQuantityChangeTax = (e) => {
    const value = e.target.value;
    this.setState({
      tax_percentage1: value,
      color_tax: false,
    });
  };

  onQuantityChangeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      autoVariant: value,
      variant: value,
      color_variant: false,
    });
  };

  updateEan(){
  //this.SuccessConfirmtoggle();
   const payload = {
    "product_id": this.state.sku_code_val,
          "ean_type": this.state.ean_val,
          "ean":this.state.new_ean
  };

  addAnalytics('Update Missing Product', 'Added New Ean', payload);

API.post('/product/updateEANInfo', { param: payload })
      .then((response) => response.data)
      .then((data) => {
      
       this.setState({
       success_message: data.reason
       })
       this.toggle();
       this.toggle1();
      })
      .catch(function(error) {});
  }


  OpenAssign1(){
  this.SuccessConfirmtoggle1();
  }

  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
      assignDisabled: false
    });
  };

  handleChangeASN(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
          console.log("value", value);
          this.setState({
            selectedASN: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

   

  handleChangeVan1(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
          console.log("value", value);
          this.setState({
            selectedVan1: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

  validateInput = (e) => {
    alert("rtyt")
    var k = e.keyCode || e.which;
    var ok = k >= 65 && k <= 90 || // A-Z
      k >= 96 && k <= 105 || // a-z
      k >= 35 && k <= 40 || // arrows
      k == 9 || //tab
      k == 46 || //del
      k == 8 || // backspaces
      (!e.shiftKey && k >= 48 && k <= 57); // only 0-9 (ignore SHIFT options)

    if(!ok || (e.ctrlKey && e.altKey)){
      e.preventDefault();
    }
  }

  ChangeLocation = (e) => {
    this.setState({
      selectedLocation1: e.target.value,
    });
  };

  ChangeOutlet = (e) => {
    this.setState({
      selectedOutlet: e.target.value,
    });
  };

  ChangeDistributor = (e) => {
      this.setState({
        selectedDistributor: e.target.value,
      });
  };

  ChangeOrder = (e) => {
      this.setState({
        selectedOrder: e.target.value,
      });
  };

  radioChangeGroup(data){
    if(data == "exsisting"){
      this.setState({
        showSelectGroup: true,
        showNewGroup: false,
        assignDisabled: true
      })
    }else if(data == "new"){
      this.setState({
        showSelectGroup: false,
        showNewGroup: true,
        assignDisabled: true
      })
    }
  }



  handleChange2 = (e) => {
    this.setState({
      task_id: e.target.value,
    });
  };
  handleChange3 = (e) => {
    this.setState({
      polaris_id: e.target.value,
    });
  };
  handleChange4 = (e) => {
    this.setState({
      task_type_value: e.target.value,
    });
  };

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  addCrate(evt, index, sorting_bin, lb_sku_id, total_qty, count, prod_config){
    //alert("tyytyu");
     let newData = this.state.arr_data1;
    var obj = {};
    obj['sorting_bin'] = sorting_bin;
    obj['lb_sku_id'] = lb_sku_id;
    obj['total_qty'] = total_qty;
    obj['crate'] = "";
    obj['crate_id'] = "";
    obj['count'] = count;
    obj['prod_config'] = prod_config;
    obj['new'] = true;
    obj['edit_val'] = 0

    newData.splice(index+1, 0, obj)
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),

    })

        


  }

  changeCrateQty(e){
    this.setState({
      crateQty: e.target.value
    })
  }

  changeCount(e){
    this.setState({
      count: e.target.value
    })
  }

  changeCrateId(e, index, id, flag){
    this.setState({
      crateId: e.target.value
    })

    var arrayData= [];

    var obj = {};
    obj['receiving_hist_id'] = id;
    obj['total_qty'] = this.state.count;
    obj['crate'] = this.state.crateQty;
    obj['crate_id'] = this.state.crateId;
    obj['crate_flag'] = flag;

    arrayData.push(obj);




    const payload = {
      arrayData
  };

API.post('/receiving/updateCrate/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
     console.log('REASON',data);
      
    })

    .then(async () => {
      
    });

  }

  addEan = (evt) => {
    this.setState({
      new_ean: evt.target.value
    })
  }

  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData = dispatchData.map((post, index) => {
      return { 
        action: <input type="radio" name="action" onChange={() => this.radioChange(post.sku7_code)}/>,
        item_code: post.sku7_code,
        item_name: post.lb_sku_product_name,
        mrp: post.mrp,
        remarks: post.remarks, 
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };



  assembleDispatchData1 = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData1 = dispatchData.map((post, index) => {
     
       return {
       action: <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index,post.isChecked, post.id)}/>,
        
        
//area_code: <span style={{color:'#70bbfc', cursor: 'pointer'}} onClick={() => this.getBillList(index,post.area_code)}>{post.area_code}</span>,
        rec_bin: post.sorting_bin__bin_address,
        product_id: post.product__lb_sku_id,
        product_desc: post.product__lb_sku_product_name,
        batch: post.receiving_request__batch,
        pkd: post.pkd,
        mrp: post.product__mrp,
        total_qty: <input value={post.received_qty}  style={{fontSize: 12, height: 31, width: 120}} type = "text"  className="form-control" placeholder="Enter Packed Qty" onChange={(evt) => this.changePackedQty(evt,index, post.id)}  />,   
        status: <span> <select
                    className="form-control"
                    disabled= {post.child_product == true ? true : false}
                    defaultValue={post.reason}
                    style={{ fontSize: 13,  width: 120 }}
                    onChange={(evt) => this.changeReason(evt,index,post.id)}
                  >
                    <option value="">Select Reason</option>
                    {
                      this.state.reasonData.length > 0 &&
                      this.state.reasonData.map((reasonData) => {
                        return (
                          <option value={reasonData.id}> {reasonData.name}</option>
                        );
                      })}
                  </select> <br/> {post.isChecked == "true" && <span className={"err_reason_"+post.id} style={{fontSize: 12, color: 'red'}}> Please Select Reason</span>}</span>, 
       


        
      };

     
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData1;
  };


  onCheck(
    taskid,
    mcCode,
    brand,
    longName,
    packsize,
    variant,
    mrp,
    ean,
    shelf_life,
    image1,
    image2,
    image3,
    image4,
    image5,
    tax_percentage,
    product_id,
    request_id,
    updated_fields,
    productName,
    variant_image,
    pack_size_image,
    task_detail_id
  ) {
    console.log(updated_fields);
    data_img = [];
    this.setState({
      apply: true,
      showTable: false,
      showFilter: false,
      updated_fields: updated_fields,
      color_variant: updated_fields.indexOf("variant") > -1 ? true : false,
      color_packSize: updated_fields.indexOf("pack_size") > -1 ? true : false,
      color_shelf: updated_fields.indexOf("shelf_life") > -1 ? true : false,
      color_product:
        updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false,
      color_mrp: updated_fields.indexOf("mrp") > -1 ? true : false,
      color_tax: updated_fields.indexOf("tax_percentage") > -1 ? true : false,
      color_brand: updated_fields.indexOf("brand") > -1 ? true : false,
      color_mc_code: updated_fields.indexOf("mc_code") > -1 ? true : false,
      color_ean: updated_fields.indexOf("ean") > -1 ? true : false,
      request_id: request_id,
      taskId: taskid,
      mcCode: mcCode,
      brand: brand,
      brand_value: brand,
      autoProductName: longName,
      autoPackSize: packsize,
      autoShelfLife: shelf_life,
      autoVariant: variant,
      packSize: packsize,
      product_name_val: productName,
      variant: variant,
      constantmrp: mrp,
      constantmrp1: mrp,
      //applyMrp: mrp,
      constantlongname: longName,
      constanttax: tax_percentage,
      constantpacksize: packsize,
      constantvariant: variant,
      constantshelflife: shelf_life,
      mrp: mrp,
      tax_percentage1: tax_percentage,
      ean: ean,
      shelf_life: shelf_life,
      image1: image1,
      image2: image2,
      image3: image3,
      image4: image4,
      image5: image5,
    });

    /*data_img = [*/

    if (image1) {
      var orderData1 = {};
      orderData1["image"] = image1;
      orderData1["text"] = "Brand";

      data_img.push(orderData1);
    }

    if (image3) {
      var orderData2 = {};
      orderData2["image"] = image3;
      orderData2["text"] = "MRP";

      data_img.push(orderData2);
    }

    if (image4) {
      var orderData3 = {};
      orderData3["image"] = image4;
      orderData3["text"] = "Shelf Life";

      data_img.push(orderData3);
    }

    if (image5) {
      var orderData4 = {};
      orderData4["image"] = image5;
      orderData4["text"] = "Product";

      data_img.push(orderData4);
    }

    if (variant_image) {
      var orderData4 = {};
      orderData4["image"] = variant_image;
      orderData4["text"] = "Variant";

      data_img.push(orderData4);
    }

    if (pack_size_image) {
      var orderData5 = {};
      orderData5["image"] = pack_size_image;
      orderData5["text"] = "Pack Size";

      data_img.push(orderData5);
    }

    console.log(data_img);

    /*{
        image: image1,
        text: 'Brand'
      },
      {
        image: image3,
        text: 'MRP'
      },
      {
        image: image4,
        text: 'Shelf Life'
      },
      {
        image: image5,
        text: 'Product'
      },
      {
        image: variant_image,
        text: 'Variant'
      },
      {
        image: pack_size_image,
        text: 'Pack Size'
      },
      
    ];*/

    localStorage.setItem("imgData", JSON.stringify(data_img));
    localStorage.setItem("longName", longName);
    localStorage.setItem("mrp", mrp);
    localStorage.setItem("ean", ean);
    localStorage.setItem("request_id", request_id);
    localStorage.setItem("task_id", taskid);
    localStorage.setItem("brand", brand);
    localStorage.setItem("task_detail_id", task_detail_id);
    localStorage.setItem("tax_percentage", tax_percentage);
    localStorage.setItem(
      "color_variant",
      updated_fields.indexOf("variant") > -1 ? true : false
    );
    localStorage.setItem(
      "color_packSize",
      updated_fields.indexOf("pack_size") > -1 ? true : false
    );
    localStorage.setItem(
      "color_shelf",
      updated_fields.indexOf("shelf_life") > -1 ? true : false
    );
    localStorage.setItem(
      "color_brand",
      updated_fields.indexOf("brand") > -1 ? true : false
    );
    localStorage.setItem(
      "color_mrp",
      updated_fields.indexOf("mrp") > -1 ? true : false
    );
    localStorage.setItem(
      "color_product",
      updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false
    );

    /*if(product_id){
      this.setState({
        product_id: product_id
      })
      this.toggle2();

    }else{
      this.setState({
        product_id: ''
      })
      this.toggle1();
    }*/

    //window.location.href = '/npi_request_data';

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "shelf_life_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          shelf_life_uom: data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "pack_size_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          pack_size_uom: data.data,
        });
      })
      .catch(function(error) {});

    this.viewImage();
  }

  onConfirm() {
    this.setState({
      ShowConfirmLoader: true,
    });
    if (
      this.state.autoLongName == "" ||
      this.state.autoShortName == "" ||
      this.state.autoHsnCode == "" ||
      this.state.autoDesc == "" ||
      this.state.autoItemtype == "" ||
      this.state.autoSellingPrice == "" ||
      this.state.autoCostPrice == "" ||
      this.state.autoMargin == "" ||
      this.state.ean == "" ||
      this.state.mrp == "" ||
      this.state.autoPackSize == "" ||
      this.state.brand == "" ||
      this.state.mrp == "" ||
      this.state.autoShelfLife == "" ||
      this.state.autoVariant == "" ||
      this.state.tax_percentage1 == ""
    ) {
      this.setState({
        showConfirmError: true,
        ShowConfirmLoader: false,
      });
      return false;
    } else {
      this.setState({
        showConfirmError: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "status_update",
          task_id: this.state.request_id,
          polaris_item_long_name: this.state.autoLongName,
          polaris_item_short_name: this.state.autoShortName,
          hsn_code: this.state.autoHsnCode,
          mc_desc: this.state.autoDesc,
          item_type: this.state.autoItemtype,
          cost_price: this.state.autoCostPrice,
          sell_price: this.state.autoSellingPrice,
          margin: this.state.autoMargin,
          ean: this.state.ean,
          mrp: this.state.mrp,
          brand: this.state.brand,
          pack_size: this.state.autoPackSize,
          tax_percentage: this.state.tax_percentage1,
          shelf_life: this.state.autoShelfLife,
          variant: this.state.autoVariant,
          product_item_name: this.state.autoProductName,
          product_id: this.state.product_id,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,

          //"status": 3,
          remarks: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          success_message: data.message,
          ShowConfirmLoader: false,
        });
        this.toggle1();
        this.toggle();

        this.fetchDispatch();
      })
      .catch(function(error) {});

    this.setState((prevState) => ({
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  

  onConfirmProduct() {
    this.setState({
      disable_submit_button: true,
      ShowEditLoader: true

    })
    var arr = [];
    for(var i = 0; i< this.state.reviewData.length; i++ ){
      var obj= {}
      obj['van_id'] = this.state.reviewData[i].van_id;
      obj['zone'] = this.state.reviewData[i].zone;


      arr.push(obj);
    }
    console.log(arr);
    
    const payload = {
      data_list: arr,
      ptl_type: "manual_ptl",
      customer: this.state.invenOwner
  };

API.post('/packing/van/v1/confirm/pick/pack/planning/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          //success_message: data.message,
          failed_message: data.message,
          disable_submit_button: false,
          ShowEditLoader: false,
          totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,
        });

        if(data.success == true){
         var objData =  Object.keys(data.data).map(function(k){return data.data[k]}).join(",");
         var objKey = Object.keys(data.data).map(function(k){return k}).join(",");
         console.log("objData", objData)
         console.log("objKey", objKey)
          this.setState({
          success_message: "Sub-Group-Id " + " " + objData + "is created for Van" + " " +  objKey,
          
        });
          this.toggle2();
          this.toggleNew();
        }else{
          //this.toggle2();
          this.toggleFailed();
        }
        

        this.fetchDispatch();
      })
      .catch(function(error) {});
  }

  /*onApply2(){
      this.setState({
        ShowpopupLoader: true
      })
      console.log(this.state.row_data);
      var arrayCartData = this.state.row_data.filter(
      (item) => {
        if(this.state.applyTax && item.tax_percentage != this.state.applyTax) {
          return false
        }
        if(this.state.hsn_code && item.hsn_code != this.state.hsn_code) {
          return false
        }
        if(this.state.applyPackSize && item.pack_size != this.state.applyPackSize) {
          return false
        }
        if(this.state.pack_size_unit && item.pack_size_uom != this.state.pack_size_unit) {
          return false
        }
        if(this.state.shelf_life_unit && item.shelf_life_uom != this.state.shelf_life_unit) {
          return false
        }
        if(this.state.applyShelfLife && item.shelf_life != this.state.applyShelfLife) {
          return false
        }
        if(this.state.applyVariant && item.variant != this.state.applyVariant) {
          return false
        }
        if(this.state.applyMrp && item.mrp != this.state.applyMrp) {
          return false
        }

        return true;
      }
    );

      console.log(arrayCartData);

      this.setState({
        row_data: arrayCartData,
        ShowpopupLoader: false
      })
  }*/

  onApply(taskid) {
    this.setState({
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      // ShowpopupLoader: true,
      showTable: false,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
            showFilter: false,
          });
        } else {
          this.setState({
            showTable: true,
            showFilter: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }

  onApply2(taskid) {
    this.setState({
      row_data: [],
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      ShowpopupLoader: true,
      showTable: true,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
          });
        } else {
          this.setState({
            showTable: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }

  SearchData(){
    console.log("ARR",this.state.arr_data)
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
   
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );
   
    

    
    console.log("filterData", newArrData);

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }

  formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('-');
}

 
  convertDate = (inputFormat) => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat)
  return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-')
}

  FromDateChange = date  => {
      console.log("Form date", date)
      this.setState({
        fromdate :  date
      }) 
      if(date != null){
      From_Date_val = this.convertDate(date);
      } else{
        From_Date_val= ""
      }
      
      
  }

  ToDateChange = date => {
      const d = new Date(date);
      this.setState({
        todate :  date
      }) 
      
       if(date != null){
      to_Date_val = this.convertDate(date); 
      } else{
        to_Date_val= ""
      }
  }

  getZone =()=> {

     const payload = {
      "station_type":"PTL",
  };

API.post('/product/product_master/v1/station/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
       console.log("Zone",data);
       this.setState({
       zoneData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }

  handleChangeEvent = (evt) =>{
    this.setState({[evt.target.name]: evt.target.value})

  }

  changeCheckedForm = (evt) => {
    this.setState({[evt.target.name]: evt.target.checked })
    console.log(evt.target.name,evt.target.checked);
  }


   getStation =()=> {

     const payload = {
    
  };

API.post('/product/product_master/v1/station/type/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
       console.log("Station",data);
       this.setState({
        stationData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }

  changePutBy = (e) =>{
    this.setState({
      put_by: e.target.value
    })
    if(e.target.value == 1){
      this.setState({
        volumeCheck: true,
      dimensionCheck: false
      })
      
    }else{
       this.setState({
        volumeCheck: false,
      dimensionCheck: true
      })
      
    }
  }







  fetchDispatch = (prod_id) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: false,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
     product_id: prod_id
  };

API.post('/product/fetchProductInfo', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        console.log("21240086020",data);
        this.setState({
          showFetchDispatchData: true,
          item_data: data,
          item_name:data['item_name'],
          item_code: data['item_code'],
          mrp:data['mrp'],
          category: data['category'],
          sub_category: data['sub_category'],
          division: data['division'],
           basepack: data['base_pack_code'],
          brand: data['brand'],
          sub_brand: data['sub_brand'],
          upc: data['upc'],
          cpo: data['cpo'],
          non_ptl: data['non_ptl'],
          each_length: data['each_length'],

          each_breadth: data['each_breadth'],
          each_weight: data['each_weight'],
          each_height: data['each_height'],
          inner_length: data['inner_length'],
          inner_height: data['inner_height'],
          inner_weight: data['inner_weight'],
          inner_breadth: data['inner_breadth'],
          outer_breadth: data['outer_breadth'],
          outer_length: data['outer_length'],
          outer_height: data['outer_height'],
          outer_weight: data['outer_weight'],
        });

        if(data['pkd_required'] == 1){
          this.setState({
            pkd_required: true
          })
        }else{
          this.setState({
            pkd_required: false
          })
        }if(data['batch_required'] == 1){
          this.setState({
            batch_required: true
          })
        }else{
          this.setState({
            batch_required: false
          })
        }

        if(data['fragile'] == 1){
          this.setState({
            fragile_item: true
          })
        }else{
          this.setState({
            fragile_item: false
          })
        }


        if(data['pkd_required'] == 1){
          this.setState({
            pkd_required: true
          })
        }else{
          this.setState({
            pkd_required: false
          })
        }

         if(data['receiving_config'] == 0){
          this.setState({
            receiving_config_outer: true,
            receiving_config_inner: false,
            receiving_config_each: false
          })
        }else if(data['receiving_config'] == 1){
          this.setState({
            receiving_config_inner: true,
            receiving_config_each: false,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 2){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: false,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 3){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: true,
            receiving_config_outer: true
          })
        }else if(data['receiving_config'] == 4){
          this.setState({
            receiving_config_each: false,
            receiving_config_inner: true,
            receiving_config_outer: true
          })
        }else if(data['receiving_config'] == 5){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: true,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 6){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: false,
            receiving_config_outer: true
          })
        }



        if(data['dispatch_config'] == 0){
          this.setState({
            dispatch_config_outer: true,
            dispatch_config_inner: false,
            dispatch_config_each: false
          })
        }else if(data['dispatch_config'] == 1){
          this.setState({
            dispatch_config_inner: true,
            dispatch_config_each: false,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 2){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: false,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 3){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: true,
            dispatch_config_outer: true
          })
        }else if(data['dispatch_config'] == 4){
          this.setState({
            dispatch_config_each: false,
            dispatch_config_inner: true,
            dispatch_config_outer: true
          })
        }else if(data['dispatch_config'] == 5){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: true,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 6){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: false,
            dispatch_config_outer: true
          })
        }

        if(data['put_by'] == 0){
          this.setState({
            volumeCheck: false,
            dimensionCheck: true,
            put_by: data['put_by']
          })
        }else if(data['put_by'] == 1){
          this.setState({
            volumeCheck: true,
            dimensionCheck: false,
            put_by: data['put_by']
          })
        }





        
        let AssignData = data.map((item) => ({
          ...item,
          isChecked: false,
          edit_val: 2,
        }));

        console.log(AssignData);
        
        //return false;

       /*this.setState({
        showUnAssignedOrder: true,
        showAssignedOrder: false,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })*/

        /*if (data.data.length == 0) {
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }*/

        

        this.setState({
         
          arr_data1: AssignData,
          tableRowsMap: this.assembleDispatchData(AssignData),
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };



  fetchDispatch1 = (prod_id) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
     //product_id: prod_id,
     mrp: this.state.mrp,
     item_code: this.state.item_code,
  };
  addAnalytics('Update Missing Product', 'Search filter', payload);

API.post('/product/fetchProductInfo', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        if(data.success == false){
          this.setState({
            failed_message: data.reason,
            loading: false
          })
          this.toggleFailed();
          return false;
        }
        this.setState({
          showFetchDispatchData: true,
          loading: false,
          item_data: data,
          item_name:data['item_name'],
          item_code: data['item_code'],
          sku_code_val: data['product_id'],
          mrp:data['mrp'],
          category: data['category'],
          sub_category: data['sub_category'],
          division: data['division'],
          basepack: data['base_pack_code'],
          brand: data['brand'],
          sub_brand: data['sub_brand'],
          upc: data['upc'],
          cpo: data['cpo'],
          non_ptl: data['non_ptl'],
          each_length: data['each_length'],
          each_breadth: data['each_breadth'],
          each_weight: data['each_weight'],
          each_height: data['each_height'],
          inner_length: data['inner_length'],
          inner_height: data['inner_height'],
          inner_weight: data['inner_weight'],
          inner_breadth: data['inner_breadth'],
          outer_breadth: data['outer_breadth'],
          outer_length: data['outer_length'],
          outer_height: data['outer_height'],
          outer_weight: data['outer_weight'],
        });


        if(data['pkd_required'] == 1){
          this.setState({
            pkd_required: true
          })
        }else{
          this.setState({
            pkd_required: false
          })
        }if(data['batch_required'] == 1){
          this.setState({
            batch_required: true
          })
        }else{
          this.setState({
            batch_required: false
          })
        }

        if(data['fragile'] == 1){
          this.setState({
            fragile_item: true
          })
        }else{
          this.setState({
            fragile_item: false
          })
        }


        if(data['pkd_required'] == 1){
          this.setState({
            pkd_required: true
          })
        }else{
          this.setState({
            pkd_required: false
          })
        }

         if(data['receiving_config'] == 0){
          this.setState({
            receiving_config_outer: true,
            receiving_config_inner: false,
            receiving_config_each: false
          })
        }else if(data['receiving_config'] == 1){
          this.setState({
            receiving_config_inner: true,
            receiving_config_each: false,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 2){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: false,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 3){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: true,
            receiving_config_outer: true
          })
        }else if(data['receiving_config'] == 4){
          this.setState({
            receiving_config_each: false,
            receiving_config_inner: true,
            receiving_config_outer: true
          })
        }else if(data['receiving_config'] == 5){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: true,
            receiving_config_outer: false
          })
        }else if(data['receiving_config'] == 6){
          this.setState({
            receiving_config_each: true,
            receiving_config_inner: false,
            receiving_config_outer: true
          })
        }



        if(data['dispatch_config'] == 0){
          this.setState({
            dispatch_config_outer: true,
            dispatch_config_inner: false,
            dispatch_config_each: false
          })
        }else if(data['dispatch_config'] == 1){
          this.setState({
            dispatch_config_inner: true,
            dispatch_config_each: false,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 2){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: false,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 3){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: true,
            dispatch_config_outer: true
          })
        }else if(data['dispatch_config'] == 4){
          this.setState({
            dispatch_config_each: false,
            dispatch_config_inner: true,
            dispatch_config_outer: true
          })
        }else if(data['dispatch_config'] == 5){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: true,
            dispatch_config_outer: false
          })
        }else if(data['dispatch_config'] == 6){
          this.setState({
            dispatch_config_each: true,
            dispatch_config_inner: false,
            dispatch_config_outer: true
          })
        }

        if(data['put_by'] == 0){
          this.setState({
            volumeCheck: false,
            dimensionCheck: true,
            put_by: data['put_by']
          })
        }else if(data['put_by'] == 1){
          this.setState({
            volumeCheck: true,
            dimensionCheck: false,
            put_by: data['put_by']
          })
        }

        
        let AssignData = data.map((item) => ({
          ...item,
          isChecked: false,
          edit_val: 2,
        }));

        console.log(AssignData);
        
        //return false;

       /*this.setState({
        showUnAssignedOrder: true,
        showAssignedOrder: false,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })*/

        /*if (data.data.length == 0) {
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }*/

        

        this.setState({
         
          arr_data1: AssignData,
          tableRowsMap: this.assembleDispatchData(AssignData),
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };










   getBillList(index, area_code){
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
    //location: this.state.selectedLocation1,
          //"data_type": "unassigned",
          group_id: this.state.selectedGroup,
          pl_group: this.state.pl_group,
          area_code: area_code,
          bill_range: this.state.bill_range,
          bill_value: this.state.bill_value,
          weight: this.state.weight,
          volume: this.state.volume,
          //outlet: this.state.selectedOutlet,
          //location: this.state.selectedLocation,
          from_data: From_Date_val,
          to_date: to_Date_val
  };

API.post('/master_ptl/view/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        console.log(data);
        this.setState({
          showFetchDispatchData1: true,
        });

        var arr = data.data;

        const sortNullishValues = (arr = []) => {
         const assignValue = val => {
            if(val == ""){
               
                return val;
            }
            else{
              return Infinity;
            };
         };
         const sorter = (a, b)=> {
            return assignValue(a.van_master) - assignValue(b.van_master);
         };
         arr.sort(sorter);
      }
      sortNullishValues(arr);
      console.log("sorter========",arr);
        
        

        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));


        

        

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: UnAssignData,
          tableRowsMap1: this.assembleDispatchData1(UnAssignData),
          showFetchDispatchData1: true,
          dispatch_status: false,
        });
        this.toggle1();
      })
      .catch(function(error) {});
  };



  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2, modalNew } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal, Failedmodal,SuccessConfirmmodal1 } = this.state;
    const { EditModal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Action",

          field: "action",
          width: 30,
        },
        
        {
          label: "Item Code",

          field: "item_code",
          width: 130,
        },
        {
          label: "Item Name",

          field: "item_name",
          width: 150,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 110,
        },


        {
          label: "Remarks",

          field: "remarks",
          width: 140,
        },




      ],

      rows: this.state.tableRowsMap,
    };




    const dispatchData1 = {
      columns: [
        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,

          field: "action",
          width: 50,
        },
        
        {
          label: "Rece Bin",

          field: "rec_bin",
          width: 100,
        },
        {
          label: "Prod Id",

          field: "product_id",
          width: 100,
        },
        {
          label: "Prod Desc",

          field: "product_desc",
          width: 130,
        },


        {
          label: "Batch",

          field: "batch",
          width: 90,
        },


        {
          label: "PKD",

          field: "pkd",
          width: 90,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 90,
        },
        {
          label: "Total Qty Actual/Expected",

          field: "total_qty",
          width: 180,
        },
        /*{
          label: "Outer Qty Actual/Expected",

          field: "outer_qty",
          width: 180,
        },
        {
          label: "Inner Qty Actual/Expected",

          field: "inner_qty",
          width: 180,
        },
        {
          label: "Each Qty Actual/Expected",

          field: "each_qty",
          width: 180,
        },*/
        {
          label: "Status",

          field: "status",
          width: 100,
        },
        {
          label: "Reason",

          field: "reason",
          width: 100,
        },

        

      ],

      rows: this.state.tableRowsMap1,
    };

    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 12 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>
             
               <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <input type = "text" defaultValue={this.state.item_data['item_code']} className="form-control group_text_filter" placeholder="Item Code" onChange={this.onItemCodeChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <input type = "text" defaultValue={this.state.item_data['mrp']} className="form-control group_text_filter" placeholder="MRP"  onChange={this.onMRPChange}/>
                </div>
              </div>

            
              
             

                <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px",  marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text"  className="form-control group_text1" placeholder= "Enter Van " onChange={this.onVanFilterChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", marginRight: 12, marginTop: 10, display: 'none' }}
              >
                <div
                  className="form__form-group-field"
                   
                >
                    <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.onBillRangeChange}
                  >
                    <option value="">Select Bill Range</option>
                   
                    <option value="greater"> {'<'}</option>
                    <option value="equal"> {'='} </option>
                    <option value="less"> {'>'}</option>
            
                  </select>
                   {/*<input type = "text" className="form-control group_text1" placeholder= "Enter Bill Range" onChange={this.onBillRangeChange}/> */}
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px", marginRight: 12 , marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text1" placeholder= "Enter Bill Value" onChange={this.onBillValueeChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px", marginRight: 6, marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text1" placeholder= "Enter Weight" onChange={this.onWeightChange}/>
                </div>
              </div>

              <div className="form__form-group col-xl-2" style={{marginLeft: 20}}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch1()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <div id="missing_prod_container">
            <div>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

               <Button style={{marginBottom: 16, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.AssignData1()}>Update</Button>
               <div className="product_container_style" style={{borderWidth: 1, borderColor: '#ddd', width: '100%', height: 180}}>
               <div style={{marginTop: 12}}>
                <span className="title_detail"> Item Details </span>
               </div>
               <div style={{marginTop: 8}}>
                <form className="form form--inline" onSubmit={handleSubmit}>
               <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px"}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7, width: '31%', float: 'left'}} for="item_code">Item Code</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled name="item_code" type = "text" defaultValue={this.state.item_data['item_code']} className="form-control group_text1"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_name">Item Name</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['item_name']} className="form-control group_text1"  name="item_name"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
               <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_name">MRP</label>
                  <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['mrp']} className="form-control group_text1"  name="mrp"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
             <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '31%', float: 'left'}} for="item_code">Category</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['category']} className="form-control group_text1"  name="category"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_code">Sub Category</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['sub_category']} className="form-control group_text1"  name="sub_category"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_code">Division</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['division']} className="form-control group_text1"  name="division"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_code">Brand</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['brand']} className="form-control group_text1"  name="brand"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_code">Sub Brand</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['sub_brand']} className="form-control group_text1"  name="sub_brand"  onChange={this.handleChangeEvent}/>
                </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '31%', float: 'left'}} for="item_code">Basepack</label>
                   <div style={{width: '70%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['base_pack_code']} className="form-control group_text1"  name="brand"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
              </form>

               </div>

               </div>



               <div className="product_container_style" style={{marginTop: 6}}>
               <div style={{marginTop: 12}}>
                <span className="title_detail"> Warehousing Data </span>
               </div>
               <div style={{marginTop: 12}}>
                <form className="form form--inline" onSubmit={handleSubmit}>
               <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '12%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">Receiving Config:</label>
                </div>
              </div>
              <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <input style={{marginTop: -8, marginRight: 4}} onChange={this.changeCheckedForm} type="checkbox" id="vehicle1" checked={this.state.receiving_config_outer} name="receiving_config_outer" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Outer</label>
                  
                  <input style={{marginTop: -8, marginRight: 4}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.receiving_config_inner} name="receiving_config_inner" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Inner</label>


                  <input style={{marginTop: -8, marginRight: 4}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.receiving_config_each} name="receiving_config_each" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Each</label>
                </div>
              </div>
                <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '13%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">Dispatch Config:</label>
                </div>
              </div>
              <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '19%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <input style={{marginTop: -8, marginRight: 4}} onChange={this.changeCheckedForm} type="checkbox" id="vehicle1" checked={this.state.dispatch_config_outer} name="dispatch_config_outer" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Outer</label>
                  
                  <input style={{marginTop: -8, marginRight: 4}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.dispatch_config_inner} name="dispatch_config_inner" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Inner</label>


                  <input style={{marginTop: -8, marginRight: 4}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.dispatch_config_each} name="dispatch_config_each" value="Bike"/>
                  <label style={{marginRight: 12}} for="vehicle1"> Each</label>
                </div>
              </div>

              <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '14%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">PKD Required:</label>
                  <input style={{marginTop: -8, marginRight: 4, marginLeft: 6}}  onChange={this.changeCheckedForm} type="checkbox" id="vehicle1" checked={this.state.pkd_required} name="pkd_required" value="Bike"/>
                </div>
              </div>


              <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '14%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">Batch Required:</label>
                  <input style={{marginTop: -8, marginRight: 4, marginLeft: 6}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.batch_required} name="batch_required" value="Bike"/>
                </div>
              </div>

                <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '12%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">Put By :</label>
                </div>
              </div>
              <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '19%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <input style={{marginTop: -8, marginRight: 4}} onChange={this.changePutBy} checked={this.state.volumeCheck} type="radio"  id="vehicle1" name="putby" value={1}/>
                  <label style={{marginRight: 12}} for="vehicle1">Volume</label>
                  
                  <input style={{marginTop: -8, marginRight: 4}} type="radio" onChange={this.changePutBy} checked={this.state.dimensionCheck} id="vehicle1" name="putby" value={0}/>
                  <label style={{marginRight: 12}} for="vehicle1"> Dimension</label>


                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '14%', float: 'left', marginLeft: 30}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label  for="item_code">Fragile Item:</label>
                  <input style={{marginTop: -8, marginRight: 4, marginLeft: 6}} type="checkbox" onChange={this.changeCheckedForm} id="vehicle1" checked={this.state.fragile_item} name="fragile_item" value="Bike"/>
                </div>
              </div>


             
             
              </form>

               </div>

               </div>



               <div className="product_container_style" style={{borderWidth: 1, marginTop: 5, borderColor: '#ddd', width: '100%'}}>
               <div style={{marginTop: 12, display: 'none'}}>
                <span className="title_detail"> Item Details </span>
               </div>
               <div style={{marginTop: 8}}>
                <form className="form form--inline" onSubmit={handleSubmit}>
                <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
               <div
                  className="form__form-group-field"
                  style={{marginTop: 5, marginLeft: 12}}
                  
                >
                  <label  for="item_code">Non-PTL:</label>
                  <input style={{marginTop: -8, marginRight: 4, marginLeft: 6}}  onChange={this.changeCheckedForm} type="checkbox" id="vehicle1" checked={this.state.non_ptl} name="non_ptl" value="Bike"/>
                </div>
              </div>
               <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">UPC</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text"  defaultValue={this.state.item_data['upc']} className="form-control" style={{width: 110}} placeholder= "" name="upc"  onChange={this.handleChangeEvent}/>
                    <span style={{color: 'red', fontSize: 11,}}> * UPC should not be 1 </span>
                  </div>
                </div>
              </div>
              <div
                className="form__form-group"
                style={{ marginBottom: "0px",  width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '35%', float: 'left'}} for="cpo">CPO</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['cpo']} className="form-control" style={{width: 110}} placeholder= "" name="cpo"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>    
               <div
                className="form__form-group "
                style={{ marginBottom: "0px",  width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  // style={{display: 'none'}}
                  
                >
                  <label style={{marginTop: 7,width: '35%', float: 'left'}} for="item_name">Shelf Life(months)</label>
                  <div style={{width: '65%', float: 'left'}}>
                  <input type = "number" defaultValue= {this.state.item_data['shelf_life']} className="form-control" style={{width: 110}} placeholder= "" name="shelf_life"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
              <div
                className="form__form-group "
                style={{ marginBottom: "0px",  width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 7,width: '35%', float: 'left'}} for="item_name">MRSL(%)</label>
                  <div style={{width: '65%', float: 'left'}}>
                  <input type = "number" defaultValue = {this.state.item_data['mrsl']} className="form-control" style={{width: 110}} placeholder= "" name="mrsl"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>
              <div
                className="form__form-group "
                style={{ marginBottom: "6px",width: '11%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{color: '#70bbfd', fontWeight: 'bold', cursor: 'pointer', marginTop: 7}}  onClick={(evt) =>this.toggle1('EAN Each', 2)}  for="item_code">* EAN Each:</label>
                </div>
              </div>
             <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Length</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" style={{width: 110}} className="form-control" defaultValue={this.state.item_data['each_length']} placeholder= "" name="each_length"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Breadth</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" style={{width: 110}} className="form-control" defaultValue={this.state.item_data['each_breadth']} placeholder= "" name="each_breadth"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "6px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Height</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['each_height']} style={{width: 110}} className="form-control" placeholder= "" name="each_height"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "6px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Weight</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" style={{width: 110}} defaultValue={this.state.item_data['each_weight']} className="form-control" placeholder= "" name="each_weight"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>





              <div
                className="form__form-group "
                style={{ marginBottom: "6px",width: '11%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{color: '#70bbfd', fontWeight: 'bold', cursor: 'pointer', marginTop: 7}} onClick={(evt) =>this.toggle1('EAN Inner', 1)}  for="item_code">* EAN Inner:</label>
                </div>
              </div>
             <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Length</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" style={{width: 110}} defaultValue={this.state.item_data['inner_length']} className="form-control" placeholder= "" name="inner_length"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "6px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Breadth</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['inner_breadth']} style={{width: 110}} className="form-control" placeholder= "" name="inner_breadth"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Height</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['inner_height']} style={{width: 110}} className="form-control" placeholder= "" name="inner_height"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Weight</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue = {this.state.item_data['inner_weight']} style={{width: 110}} className="form-control" placeholder= "" name="inner_weight"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>






              <div
                className="form__form-group "
                style={{ marginBottom: "6px",width: '11%', float: 'left', marginLeft: 12}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{color: '#70bbfd', fontWeight: 'bold', cursor: 'pointer', marginTop: 7}}  onClick={(evt) =>this.toggle1('EAN Outer', 0)} for="item_code">* EAN Outer:</label>
                </div>
              </div>
             <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Length</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input defaultValue={this.state.item_data['outer_length']} type = "text" style={{width: 110}} className="form-control" placeholder= "" name="outer_length"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Breadth</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['outer_breadth']} style={{width: 110}} className="form-control" placeholder= "" name="outer_breadth"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Height</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['outer_height']} style={{width: 110}} className="form-control" placeholder= "" name="outer_height"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group"
                style={{ marginBottom: "0px",width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <label style={{marginTop: 7, width: '35%', float: 'left'}} for="item_code">Weight</label>
                   <div style={{width: '65%', float: 'left'}}>
                   <input type = "text" defaultValue={this.state.item_data['outer_weight']} style={{width: 110}} className="form-control" placeholder= "" name="outer_weight"  onChange={this.handleChangeEvent}/>
                  </div>
                </div>
              </div>

              </form>

               </div>

               </div>

              </div>

            </div>

            </div>
          )}
        </Card>

         <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKNew}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>


        <Modal isOpen={modal} backdrop="static" toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalFailed} backdrop="static" toggle={this.toggleFailed}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
           <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleFailed}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

          <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <h5>{this.state.failed_message} </h5>
          </div>
          <ButtonToolbar className="modal__footer">
             <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.UpdateData}
            >
              Yes
            </Button>
            <button
              style={{ marginLeft: 15 }}
              className="modal_cancel"
              onClick={this.Failedtoggle}
            >
              Cancel
            </button>

            
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modal1}
          backdrop="static"
          toggle={this.toggle1}
          style={{ maxWidth: 620, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              {this.state.title_val}
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 10 }}>
            
            <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '34%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '40%', float: 'left'}} for="item_code">Item Code</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['item_code']} className="form-control group_text_2" placeholder= "" onChange={this.brandChange}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '34%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '40%', float: 'left'}} for="item_code">Item Name</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['name']} className="form-control group_text_2" placeholder= "" onChange={this.subBrandChange}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '32%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '40%', float: 'left'}} for="item_code">MRP</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input disabled type = "text" defaultValue={this.state.item_data['mrp']} className="form-control group_text_2" placeholder= "" onChange={this.subBrandChange}/>
                  </div>
                </div>
              </div>  

              <hr style={{marginTop: 40}}/> 

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '32%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                   <div style={{width: '60%', float: 'left', paddingLeft: 8}}>
                   <input  type = "text" className="form-control group_text1" placeholder= "Add New EAN" onChange={this.addEan}/>
                  </div>
                </div>
              </div>  

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '32%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >

                <ButtonToolbar className="modal__footer">
                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.updateEan}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Submit
                </Button>
              </ButtonToolbar>
                  
                   
                </div>
              </div> 

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '90%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                  <h5 style={{paddingLeft: 10, fontWeight: 'bold', marginTop: 14}}> List of Eans: </h5>
                </div>
              </div>   

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '90%', float: 'left', paddingLeft: 10}}
              >
                <div
                  className="form__form-group-field ean_list_container" style={{height: 100,}}
                  
                >
                <ul>
                {this.state.ean_list.map((item,index)=> (
                    <li key={index}> {item}</li>

                  ))}
                
                </ul>
                </div>
              </div> 

                

                

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <button

                  className="modal_cancel"
                  onClick={this.toggleNPICancel}
                >
                  Cancel
                </button>

                
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modal2}
          toggle={this.toggle2}

          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Review Data
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            >
              

              
              

              
            </div>

            

            {this.state.apply1 && (
              <div style={{ width: "100%", float: "left" }}>
                <span style={{color: 'red'}}>{this.state.reviewErr}</span>
                <table
                  className="table table-bordered table-hover"
                  id="tab_logic"
                >
                  <thead style={{ textAlign: "left" }}>
                    <tr>

                      <th>Van Name</th>
                      <th>Total Bill</th>
                      <th>Total Values </th>
                      <th>Total Weight </th>
                      <th>Location </th>
                      <th>Zone </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                      {this.state.reviewData.length > 0 &&
                        this.state.reviewData.map((item, index) => (
                          <tr>
                            <td>{item.van_name}</td>
                            <td>{item.total_bills}</td>
                            <td>{item.total_values}</td>
                            <td>{item.total_weight}</td>
                            <td>{item.locations}</td>
                            {/*<td>
                              <select
                                className="form-control"
                                value={this.state.store_id}
                                style={{ fontSize: 13 }}
                                
                                onChange={(evt) =>
                                  this.ChangeStation(evt, index)
                                }

                              >
                                <option value="">Select Station</option>
                                {
                                  this.state.stationData.length > 0 &&
                                  this.state.stationData.map((stationData) => {
                                    return (
                                      <option value={stationData.id}> {stationData.name}</option>
                                    );
                                  })}
                              </select>
                            </td>*/}
                            <td>
                              <select
                                className="form-control"
                                value={this.state.store_id}
                                style={{ fontSize: 13 }}
                                
                                onChange={(evt) =>
                                  this.ChangeZone(evt, index)
                                }
                              >
                                <option value="">Select zone</option>
                                {
                                  this.state.zoneData.length > 0 &&
                                  this.state.zoneData.map((zoneData) => {
                                    return (
                                      <option value={zoneData.id}> {zoneData.name} - {zoneData.type}</option>
                                    );
                                  })}
                              </select>
                            </td>
                            </tr>
                        ))}

                    
                  </tbody>
                </table>

                
                
                

                

               
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 12 }}>
              <ButtonToolbar className="modal__footer">
                <button
                  className="modal_cancel"
                  onClick={this.toggle2}
                >
                  Cancel
                </button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.onConfirmProduct}
                >
                  {this.state.ShowEditLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Create
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal isOpen={SuccessConfirmmodal} backdrop="static" toggle={this.SuccessConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter Van Name: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text"  className="form-control group_text1" placeholder= "Enter Van Name" onChange={this.handleChangeVan1} />
               {/*<select
                    className="form-control select_style"
                    value={this.state.store_id}
                    style={{ fontSize: 13,  width: 220 }}
                    onChange={this.handleChangeVan}
                  >
                    <option value="">Select Van</option>
                    {
                      this.state.van_list.length > 0 &&
                      this.state.van_list.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>*/}
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{  marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
              disabled={this.state.assignDisabled}
            >
            {this.state.assignLoader && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>

         <Modal isOpen={SuccessConfirmmodal1} backdrop="static" toggle={this.SuccessConfirmtoggle1}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter ASN: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text" className="form-control group_text1" placeholder= "Enter ASN" onChange={this.handleChangeASN}/>
               {/*<select
                    className="form-control select_style"
                    value={this.state.store_id}
                    style={{ fontSize: 13,  width: 220 }}
                    onChange={this.handleChangeVan}
                  >
                    <option value="">Select Van</option>
                    {
                      this.state.van_list.length > 0 &&
                      this.state.van_list.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>*/}
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle1}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData1}
              disabled={this.state.assignDisabled1}
            >
            {this.state.assignLoader1 && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));